const PULL_EVENE_TYPE_MAP = {
    'LANDPAGE_EXPOSE': '1',
    'BTN_CLICK': '2',
};
const LAUNCH_APP_COMMON_PARAMS_KEY = [
    'x_act_key',
    'xid',
    'entrance_channel',
    'prod_key',
    'dchn',
    'xpsid',
    'xpsid_from',
    'xpsid_root',
    'xbiz',
    'uid',
    'xenv',
    'xspm_from',
];
export { LAUNCH_APP_COMMON_PARAMS_KEY, PULL_EVENE_TYPE_MAP };
